import {
    createApi,
    fetchBaseQuery
  } from "@reduxjs/toolkit/query/react";
import { RootState } from '../'

const APIM_SUBSCRIPTION_VALUE =  process.env.REACT_APP_DATA_CHATBOT_APIM_SUBSCRIPTION_VALUE
const BASE_URL = process.env.REACT_APP_REPORT_SERVICE_API_URL

export interface ChatLogParam {
    user_id: string,
    query: string,
    response: string
}

export interface GenieLogParam {
    email: string,
    question: string,
    response: string,
    sql: string,
    source: string,
    sql_explanation: string,
    space_id: string,
    conversation_id: string
}

// export interface StringMap {
//     [key: string]: string
// }

// export interface ChatbotResultType {
//     data: StringMap[],
//     error: any,
//     isLoading: boolean
// }

export const chatLog = createApi({
    reducerPath: "chatLog",
    baseQuery: fetchBaseQuery({
        baseUrl: BASE_URL,
        prepareHeaders: async (headers, { getState }) => {
            const state = getState() as RootState
            headers.set('Content-Type', `application/json`)
            headers.set('Ocp-Apim-Subscription-Key', `${APIM_SUBSCRIPTION_VALUE}`)
            headers.set('Authorization', `Bearer ${state.auth.idToken}`)
            return headers
        }
    }),
    tagTypes: ["log"],
    endpoints: (builder) => ({
        log: builder.mutation({
            query: (body: ChatLogParam) => ({
                url: `/chatbot/log`,
                method: 'POST',
                body
            })
        }),
        genieLog: builder.mutation({
            query: (body: GenieLogParam) => ({
                url: `/Chatbot/genie-log`,
                method: 'POST',
                body
            })
        }),
        fetchGenieLog: builder.query({
            query: (email: string) => ({
                url: `/Chatbot/genie-logs?email=${email}`,
                method: 'GET'
            })
        })
        })
    })
    
export const {
    useLogMutation,
    useGenieLogMutation,
    useFetchGenieLogQuery
  } = chatLog;